import PropTypes from "prop-types";
import searchIcon from "../../assets/search.svg";

const SearchBar = ({ search, setSearch}) => {
  return (
    <div className="relative px-4 w-full">
      <img
        src={searchIcon}
        alt="search-icon"
        className="absolute left-6 top-1/2 transform -translate-y-1/2 w-5 h-5"
      />
      <input
        type="text"
        placeholder="Search"
        className="pl-10 pr-4 py-2 w-85 rounded-3xl text-sm font-light bg-gray-200 text-gray-600 focus:outline-none"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
    </div>
  );
};

SearchBar.propTypes = {
  search: PropTypes.string.isRequired,
  setSearch: PropTypes.func.isRequired
};

export default SearchBar;
  